module.exports = __webpack_public_path__ + "static/media/logo2.f70a836f.png";